<template>
	<div class="buddies_list_comp">
		<div
			class="buddies_box"
			v-for="(buddie, idx) in dataList"
			:key="buddie.CallerIDName"
			@click="goDetail(buddie)"
		>
			<!-- 个人信息 -->
			<div class="profile">
				<!-- 头像 -->
				<div class="avatar">
					<el-avatar :src="computedLogo(buddie.CallerIDName)"></el-avatar>
				</div>
				<!-- 姓名和电话号码 -->
				<div class="name_phone">
					<!-- 姓名 -->
					<div class="name">
						{{ computedName(buddie.CallerIDName) }}
					</div>
					<!-- 电话号码 -->
					<div class="phone">
						{{ buddie.CallerIDName }}
					</div>
				</div>
			</div>
			<!-- 通话信息 -->
			<div class="info">
				<div class="time">{{ $SIP.utcToLocal(buddie.lastActivity) }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from "vuex";
export default {
	name: "BuddiesList",
	props: ["BuddiesList", "searchText"],
	computed: {
		...mapGetters("sysInit", {
			allUsersAndCustomers: "allUsersAndCustomers",
    	}),
		dataList() {
			return this.searchCallHistories(this.BuddiesList, this.searchText);
		},
	},
	methods: {
		goDetail(buddie) {
			let user = {
				name: this.computedName(buddie.CallerIDName),
				logo: this.computedLogo(buddie.CallerIDName),
			}
			this.$emit("showDetail", buddie, user);
		},
		searchCallHistories(callHistories, searchText) {
			return callHistories.filter(i => {
				if (i.CallerIDName.includes(searchText)) {
					// 匹配上手机号时直接返回true
					return true;
				}
				let userOrCustomer = _.find(this.allUsersAndCustomers, {phone: i.CallerIDName});
				if (userOrCustomer && (userOrCustomer.lastname + userOrCustomer.firstname).includes(searchText)) {
					return true;
				}
				return false;
			});
		},
		computedLogo(phone) {
			let logo = process.env.VUE_APP_DEFAULT_PROFILE_PHOTO;
			let userOrCustomer = _.find(this.allUsersAndCustomers, {phone});
			if (userOrCustomer && userOrCustomer.logo) {
				logo = userOrCustomer.logo;
			}
			return logo;
		},
		computedName(phone) {
			let name = "";
			let userOrCustomer = _.find(this.allUsersAndCustomers, {phone});
			if (userOrCustomer) {
				name = userOrCustomer.name;
			}
			return name;
		},
	},
};
</script>

<style lang="scss" scoped>
.buddies_box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	cursor: pointer;
	.profile {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		column-gap: 10px;
		.avatar {
			
		}
		.name_phone {
			.name {
				text-wrap: nowrap;
			}
			.phone {
				color: gray;
				font-size: 12px;
			}
		}
	}
	.info {
		.time {
			font-size: 14px;
			color: #aaa;
			text-align: right;
		}
	}
}
.buddies_box + .buddies_box {
	margin-top: 20px;
}
</style>
